import { app } from '@/store';

function loading(isLoading: boolean): void {
  app.loading(isLoading);
}

export default loading;
